import React from 'react';
import Radium from 'radium';

import AuthFormWrapper from '../../components/AuthFormWrapper';

const SignUp = ({ children }) => <AuthFormWrapper>{children}</AuthFormWrapper>;

export default Radium(SignUp);
